import logService from '../../services/wss/logService3';
import responseHelper from '../../services/ResponseHelper';
import styleService from '../../services/StyleService';
import gatewayService from '../../services/GatewayService';
import CoreBase from '../../services/engines/CoreBase';

const _name = 'StyleFetcher';

class StyleFetcher extends CoreBase {
    /**
     * Fetches all style notes from the service.
     * @returns {object[]|null} array of style notes, or null on failure
     */
    fetch = async () => {
        // try {
        //     const resp = await styleService.getStyles();

        //     if (responseHelper.check(resp, 'fetch', _name) < 0) {
        //         return null;
        //     }

        //     return resp.data.items ?? null;
        // } catch (error) {
        //     logService.logError(`${_name}.fetch: ${error.message}`);
        //     return null;
        // }

        try {
            const topic = 'Jerny.StyleNotes';
            const page = 1;
            const PAGE_SIZE = 25;

            const resp = await gatewayService.getUserEntries(topic, page, PAGE_SIZE);
            if (responseHelper.check(resp, '', `${_name}.fetch`) < 0) {
                return null;
            }

            const items = resp.data.items.filter((x) => x.title.startsWith('BodyEditorStyle'));
            const r = {
                entries: items,
                size: resp.data.pageSize,
                total: resp.data.totalItems,
                page: resp.data.pageNum,

                pages: resp.data.totalPages,
            };

            return r;
        } catch (error) {
            this.logError(`fetch`, `${error.message}`);
            return null;
        }
    };
}

const styleFetcher = new StyleFetcher();
export default styleFetcher;
